import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { VaFormsModule } from '@vendasta/forms';
import { EmptyStateModule } from '@vendasta/uikit';
import { SalesOrderDetailsCardComponent } from './sales-order-details-card.component';
import { SalesOrderTagsService } from './sales-order-details-tags/sales-order-details-tags.service';
import { SalesOrderDetailsTagsComponent } from './sales-order-details-tags/sales-order-details-tags.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SalesOrderDetailsRequestedActivationComponent } from './sales-order-details-requested-activation/sales-order-details-requested-activation.component';
import { SalesOrderDetailsContractDurationComponent } from './sales-order-details-contract-duration/sales-order-details-contract-duration.component';
import { SalesOrderDetailsNotesComponent } from './sales-order-details-notes/sales-order-details-notes.component';
import { TranslateModule } from '@ngx-translate/core';
import { SalesOrderDetailsCustomerNotesComponent } from './sales-order-details-customer-notes/sales-order-details-customer-notes.component';
import { LexiconModule } from '@galaxy/lexicon';
import baseTranslation from '../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../shared/constants';
import { GalaxyUploaderModule } from '@vendasta/galaxy/uploader';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatListModule,
    MatProgressSpinnerModule,
    EmptyStateModule,
    MatExpansionModule,
    VaFormsModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatButtonModule,
    MatDatepickerModule,
    MatInputModule,
    MatSelectModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    GalaxyUploaderModule,
    GalaxyBadgeModule,
    GalaxyFormFieldModule,
    GalaxyButtonLoadingIndicatorModule,
  ],
  providers: [SalesOrderTagsService],
  declarations: [
    SalesOrderDetailsCardComponent,
    SalesOrderDetailsTagsComponent,
    SalesOrderDetailsRequestedActivationComponent,
    SalesOrderDetailsContractDurationComponent,
    SalesOrderDetailsNotesComponent,
    SalesOrderDetailsCustomerNotesComponent,
  ],
  exports: [SalesOrderDetailsCardComponent, SalesOrderDetailsTagsComponent],
})
export class SalesOrderDetailsCardModule {}
